import { type FC, type ReactNode } from 'react';

import { mergeSx } from '../../../util/mui/sx';
import { Checkbox, type CheckboxProps } from '../../input/Checkbox';
import { Centered } from '../../structural/Centered';
import { Tooltip } from '../../tooltips/Tooltip';
import { ConditionallyRender } from '../../util/ConditionallyRender';

export interface GenericListCheckboxProps extends CheckboxProps {
  readonly isSelectable?: boolean;
  readonly tooltip?: ReactNode;
}

export const GenericListCheckbox: FC<GenericListCheckboxProps> = ({
  isSelectable,
  tooltip,
  ...props
}) => (
  <ConditionallyRender show={isSelectable !== false}>
    <Tooltip title={tooltip}>
      <Centered aspectRatio={1} data-testid='checkbox-wrapper' maxHeight='100%'>
        <Checkbox
          {...props}
          size='small'
          sx={mergeSx(t => ({ padding: t.spacing(0.75) }), props.sx)}
        />
      </Centered>
    </Tooltip>
  </ConditionallyRender>
);
